export default __webpack_public_path__ + "static/media/duct-manufacturing.4b211b68.jpg";